import {
  removeUserInfoFromLocalStorage,
  removeProductFromSessionStorage
} from '@/utils/auth'

import { getStringByTextKey } from '@/utils/getStringByTextKey'
import { getLanguage } from './localization'

export default (res, callback) => {
  if (res.body) {
    let err = res.body
    if (err.errorCode) {
      // let path = window.location.pathname.split('/').pop()
      let path = window.location.pathname.split('/')[2]
      const lang = getLanguage()
      console.log('path1', path)
      switch (err.errorCode) {
        case 'INVALID_SESSION':
          if (path !== 'login' && path !== 'console') {
            window.alert(getStringByTextKey('common.alert.sessionExpired'))
          }
          removeUserInfoFromLocalStorage()
          removeProductFromSessionStorage()
          window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
          break
        case 'INTERNAL_SERVER_ERROR':
          window.alert(getStringByTextKey('common.alert.serverError'))
          break
        default:
          if (callback) {
            callback()
          }
          break
      }
    } else {
      alert("getStringByTextKey('common.alert.serverError')")
    }
  } else {
    switch (res.status) {
      case 401:
        // let path = window.location.pathname.split('/').pop()
        let path = window.location.pathname.split('/')[2]
        const lang = getLanguage()
        console.log('path2', path)
        if (path !== 'login' && path !== 'console') {
          window.alert(getStringByTextKey('common.alert.sessionExpired'))
        }
        removeProductFromSessionStorage()
        removeUserInfoFromLocalStorage()
        window.location.href = `${process.env.PUBLIC_URL}/${lang}/login`
        break
      default:
        if (callback) {
          callback()
        }
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/handleAPIException.js